import React, { useEffect, useState } from "react";
import { Elements, RecurlyProvider } from "@recurly/react-recurly";

export function RecurlyElements({ children }: { children: React.ReactNode }) {
  let [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  // we have to do this because RecurlyProvider throws an error if the window was not loaded yet
  if (!mounted) {
    return null;
  }

  return (
    <RecurlyProvider publicKey={process.env.PUBLIC_RECURLY_PUBLIC_KEY}>
      <Elements>{children}</Elements>
    </RecurlyProvider>
  );
}
